<template>
    <div>
        <div class="container-fluid white-bg no-shadow">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <div class="land-t-delimeter" style="margin-bottom: 60px;"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <p>Дети дошкольного возраста обожают гаджеты. Для родителей это проблема, ведь ребенку становятся не интересны книги и раскраски. Но увлечение малыша планшетом можно использовать с пользой, например, для изучения иностранных языков. В этом поможет инновационная образовательная платформа HomeTeacher от сети международных языковых школ &laquo;Полиглотики&raquo;.</p>

                        <h2 class="greenh2">Что собой представляет платформа?</h2>

                        <p>HomeTeacher &ndash; это платформа, на которой выложены онлайн уроки английского для детей 4, 5 и 6 лет, а также есть курсы для малышей и школьников. С ней изучать английский можно в любом месте и в любое удобное время.</p>

                        <p>Чтобы начать дистанционное обучение дошкольников английскому языку, родителям достаточно указать возраст ребенка и язык, который он хочет изучить, а потом выбрать подходящий курс из вариантов, представленных системой. После регистрации и оплаты у родителя и ученика появится свой личный кабинет, в котором можно найти методические материалы и видеоуроки. Доступ к ним сохраняется и после завершения курса на срок до 12-18 месяцев, поэтому ребенок в любое время может повторить ранее пройденный материал.</p>

                        <p>Сложностей с самостоятельным обучением как у детей в 5-6, так в 7 или 8 лет тоже не возникнет. Все материалы изложены в логической последовательности, поэтому родители с легкостью смогут включить ребенку подходящий ролик.</p>

                        <h2 class="greenh2">Какие результаты дает обучение?</h2>

                        <p>Онлайн обучение дошкольников английскому языку &ndash; это отличная альтернатива традиционным офлайн-урокам. Занимаясь удаленно, ребенок в игровой форме усваивает иностранный язык, формируя тем самым у себя навыки билингвизма.</p>

                        <p>Онлайн курсы английского языка для дошкольников помогают:</p>

                        <ul>
                            <li><span>Развить память, воображение, внимание и творческое мышление, ведь учитель на видео предлагает детям разные виды деятельности, соответствующие возрасту;</span></li>
                            <li><span>Сформировать или расширить уже существующий словарный запас за счет общения с носителем иностранного языка или опытным педагогом;</span></li>
                            <li><span>Научиться воспринимать и понимать английскую речь на слух и вести простой диалог на понятные темы;</span></li>
                            <li><span>Обучиться самостоятельности и ответственности, повысить успеваемость в школе.</span></li>
                        </ul>

                        <p>Онлайн школа для дошкольников по английскому языку работает по тому же принципу, что и центры международной сети &laquo;Полиглотики&raquo;. В работе используются те же методики и приемы, что и на офлайн-уроках. Методисты нашей сети разработали более 70 программ для учеников разных возрастов, причем каждая программа по-своему уникальна, соответствует отечественным и мировым стандартам и позволяет усвоить самый сложный материал в доступном для детей формате игры.</p>

                        <p>После завершения курса каждому ребенку выдают сертификат, подтверждающий успешное завершение учебы.</p>

                        <p>Начинать учить английский с &laquo;Полиглотиками&raquo; можно не только в дошкольном возрасте. У нас есть отдельные курсы для малышей до 3 лет и для школьников. Благодаря этому родители с раннего возраста смогут формировать у детей навыки билингвизма, даже не посещая офлайн-занятий. Ознакомиться со списком курсов и выбрать подходящий вы сможете на официальном сайте платформе HomeTeacher.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Lang1Age2"
    }
</script>

<style scoped>
    .no-shadow p,li{color: #000; font-size: 18px;}
    .no-shadow ul li{margin-bottom: 20px; padding-left: 10px;}
    .no-shadow ul {list-style-image: url(~@/assets/hometeacher/images/redok.png);}
    .no-shadow{margin-bottom: 70px;}
    .no-shadow li{font-family: "Manrope Bold"; color:#5ab947;}
    .no-shadow li span {font-family: "Manrope Light"; color: #000;}
    .no-shadow ol li{margin-bottom: 20px; padding-left: 5px;}
</style>
